<template>
  <div class="moow-master-container play-background">
    <nav-basic :progress="2" title :disable="true"></nav-basic>
    <div class="container">
      <b-row class="step-header">
        <b-col md="6" cols="12">
          <p class="moow-header">
            Hi {{currentUserName}}, let's put up your rental
            <br />and get you earning in no time
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="6" cols="12">
          <md-card class="island-card">
            <md-card-content>
              <b-row class="add-step-container first">
                <b-col style="text-align:left">
                  <p class="moow-subheader">Start with the basics</p>
                  <p
                    class="moow-info-txt"
                  >We’ll go through the basics about your property, its type, size and other</p>

                  <moow-button
                    v-if="basicAsPrimary"
                    :type="['light']"
                    :btnText="basicText"
                    @mClick="basic"
                  />
                  <moow-button
                    v-else
                    :type="['dark', 'outlined', 'flat']"
                    :btnText="basicText"
                    @mClick="basic"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col class="divider"></b-col>
              </b-row>
              <b-row id="scene">
                <b-col>
                  <p class="moow-subheader">Set the scene</p>
                  <p
                    class="moow-info-txt"
                  >Walkthrough taking the best photos and writing a description the market is looking for.</p>

                  <moow-button
                    id="sceneBtn"
                    v-if="sceneAsPrimary"
                    :type="['light']"
                    :btnText="sceneText"
                    @mClick="scene"
                  />
                  <moow-button
                    id="sceneBtn"
                    v-else
                    :type="['dark', 'outlined', 'flat']"
                    :btnText="sceneText"
                    @mClick="scene"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col class="divider"></b-col>
              </b-row>
              <b-row id="price" class="mb-5">
                <b-col>
                  <p class="moow-subheader">Get ready for customers</p>
                  <p class="moow-info-txt">Go through setting the price and final details.</p>

                  <moow-button
                    id="priceBtn"
                    v-if="customersAsPrimary"
                    :type="['light']"
                    :btnText="priceText"
                    @mClick="price"
                  />
                  <moow-button
                    id="priceBtn"
                    v-else
                    :type="['dark', 'outlined', 'flat']"
                    :btnText="priceText"
                    @mClick="price"
                  />
                </b-col>
              </b-row>
            </md-card-content>
          </md-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getUserUid } from "../functions.js";
export default {
  name: "addListing",
  data() {
    return {
      loadingText: "",
      basicText: "",
      priceText: "",
      sceneText: "",
      inserted: false,
      userFirstName: "",
      basicAsPrimary: true,
      sceneAsPrimary: false,
      customersAsPrimary: false,
    };
  },
  created() {
    if (sessionStorage.getItem("insertedId") != null) {
      this.inserted = true;
    }
    if (
      sessionStorage.getItem("signedIn") &&
      sessionStorage.getItem("liu_displayname")
    ) {
      this.userFirstName = sessionStorage
        .getItem("liu_displayname")
        .split(" ")[0];
    }
  },
  mounted() {
    if (sessionStorage.getItem("newListing") == "true") {
      this.basicText = "Continue";
    } else {
      let gd = sessionStorage.getItem("genDet");
      let td = sessionStorage.getItem("techDet");
      this.basicText = "Edit";
      if (!gd || gd.pictureUrls == undefined) {
        sessionStorage.setItem("sceneStatus", 0);
      } else {
        sessionStorage.setItem("sceneStatus", 1);
      }
    }
    if (sessionStorage.getItem("basicStatus") == 0) {
      document.getElementById("sceneBtn").style.display = "none";
      document.getElementById("scene").style.opacity = 0.4;
      document.getElementById("priceBtn").style.display = "none";
      document.getElementById("price").style.opacity = 0.4;
    } else if (sessionStorage.getItem("sceneStatus") == 0) {
      document.getElementById("sceneBtn").style.display = "initial";
      document.getElementById("scene").style.opacity = 1;
      document.getElementById("priceBtn").style.display = "none";
      document.getElementById("price").style.opacity = 0.4;
      this.basicText = "Edit";
      this.sceneText = "Continue";
      this.basicAsPrimary = false;
      this.sceneAsPrimary = true;
    } else if (sessionStorage.getItem("priceStatus") == 0) {
      document.getElementById("sceneBtn").style.display = "initial";
      document.getElementById("scene").style.opacity = 1;
      document.getElementById("priceBtn").style.display = "initial";
      document.getElementById("price").style.opacity = 1;
      this.basicText = "Edit";
      this.sceneText = "Edit";
      this.priceText = "Continue";
      this.basicAsPrimary = false;
      this.sceneAsPrimary = false;
      this.customersAsPrimary = true;
    } else {
      document.getElementById("sceneBtn").style.display = "none";
      document.getElementById("scene").style.opacity = 0.4;
      document.getElementById("priceBtn").style.display = "none";
      document.getElementById("price").style.opacity = 0.4;
    }
  },
  computed: {
    currentUserName() {
      var name = "";
      this.$store.getters.user.firstName
        ? (name = this.$store.getters.user.firstName)
        : void 0;
      return name;
    },
  },
  methods: {
    basic() {
      sessionStorage.setItem("basicStatus", 1);
      this.$router.push({
        name: "adr",
      });
    },
    price() {
      this.$router.push({
        name: "price1",
      });
    },
    scene() {
      if (sessionStorage.getItem("uploadedSomeImages") == "true") {
        this.$router.push({
          name: "scene1",
        });
      } else {
        this.$router.push({
          name: "scene1",
        });
      }
    },
    save() {
      // No saving is done here cause each individual step already saves user progress.
      this.$router.push({
        name: "dashboard",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../assets/styles/global.css";

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.card-text {
  margin-top: 0.75rem;
}

.divider {
  width: 492px;
  height: 1px;
  background-color: #ededed;
  margin-top: 20px;
  margin-bottom: 20px;
}

.button {
  margin-top: 10px;
  width: 150px;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #1f8efa;
  border-radius: 4px;
  border: solid 1px #1f8efa;
  background-color: #ffffff;
}

.button-add-step {
  padding: 0.5em 1em 0.5em 1em;
  font-weight: bold;
}

.text-title {
  font-size: 30px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4a4a4a;
}
</style>



// WEBPACK FOOTER //
// src/components/AddListing1.vue